import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, MenuItem, Button,
  FormControlLabel, Checkbox
} from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';

export default function DashboardSettingsDialog({
  open, onClose, onSave,
  tempSettings, setTempSettings
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SettingsIcon sx={{ mr: 1 }} />
          Dashboard Settings
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="subtitle2" gutterBottom>Pay Period</Typography>
          <TextField
            select
            fullWidth
            value={tempSettings.payPeriod}
            onChange={(e) => setTempSettings(prev => ({ ...prev, payPeriod: e.target.value }))}
            size="small"
            sx={{ mb: 3 }}
          >
            <MenuItem value="weekly">Weekly (Sun - Sat)</MenuItem>
            <MenuItem value="biweekly">Bi-Weekly (14 days)</MenuItem>
            <MenuItem value="semimonthly">Semi-Monthly (1st-15th, 16th-end)</MenuItem>
          </TextField>

          <Typography variant="subtitle2" gutterBottom>Display Options</Typography>
          <Box sx={{ pl: 1, mb: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSettings.showUnpaidBalance}
                  onChange={(e) => setTempSettings(prev => ({ ...prev, showUnpaidBalance: e.target.checked }))}
                />
              }
              label="Show unpaid balance card"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSettings.showCharts}
                  onChange={(e) => setTempSettings(prev => ({ ...prev, showCharts: e.target.checked }))}
                />
              }
              label="Show analytics charts"
            />
          </Box>

          <Typography variant="subtitle2" gutterBottom>Alert Preferences</Typography>
          <Box sx={{ pl: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSettings.showNoEntryAlert}
                  onChange={(e) => setTempSettings(prev => ({ ...prev, showNoEntryAlert: e.target.checked }))}
                />
              }
              label="Show 'No time logged today' alert"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSettings.showUnpaidExpensesAlert}
                  onChange={(e) => setTempSettings(prev => ({ ...prev, showUnpaidExpensesAlert: e.target.checked }))}
                />
              }
              label="Show 'Pending reimbursements' alert"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSettings.showLowHoursAlert}
                  onChange={(e) => setTempSettings(prev => ({ ...prev, showLowHoursAlert: e.target.checked }))}
                />
              }
              label="Show 'Low weekly hours' alert"
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained">Save Settings</Button>
      </DialogActions>
    </Dialog>
  );
}
